import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment, EnvironmentConfigService } from '../environment';
import { CreateNotification } from '../store';
import { UserService } from '../user';
import * as i0 from "@angular/core";
import * as i1 from "../../../../model/src/lib/environment.token";
import * as i2 from "../environment/environment-config.service";
import * as i3 from "@angular/common/http";
import * as i4 from "../user/user.service";
import * as i5 from "@ngrx/store";
export class LabelsService {
    constructor(environment, environmentConfigService, http, userService, store) {
        this.environment = environment;
        this.environmentConfigService = environmentConfigService;
        this.http = http;
        this.userService = userService;
        this.store = store;
        this.labelCreatedSource = new Subject();
        this.labelCreated$ = this.labelCreatedSource.asObservable();
        this.apiUrl =
            this.environmentConfigService.getEnvironmentConfigs().apis.platform.url +
                '/' +
                'business-acct-service/v2';
        /*this.environment.serviceUrlList[
            PlatformServiceName.BusinessAccountService
          ];*/
        this.businessAccountId = this.userService.getBusinessAccount();
    }
    getLabelsList() {
        const baidToUse = localStorage.getItem('selectedBaid') || this.businessAccountId;
        const url = `${this.apiUrl}/businessAcct/labels?businessAccountUuid=${baidToUse}`;
        return this.http
            .get(url)
            .pipe(map(labelsList => labelsList.labelDefinitions));
    }
    createLabel(label) {
        const { key, value } = label;
        const body = {
            businessAccountUuid: this.businessAccountId,
            labelDefinition: {
                id: null,
                key,
                value
            }
        };
        return this.http
            .post(this.apiUrl + '/businessAcct/labels/create', body)
            .pipe(catchError(error => {
            if (error.status === 409) {
                this.store.dispatch(new CreateNotification(`Label "${(value || key).toUpperCase()}" already exists or is greater than 63 characters.`));
                return null;
            }
            else {
                throw error;
            }
        }));
    }
    notifyLabelWasCreated() {
        this.labelCreatedSource.next(true);
    }
}
LabelsService.ngInjectableDef = i0.defineInjectable({ factory: function LabelsService_Factory() { return new LabelsService(i0.inject(i1.ENVIRONMENT), i0.inject(i2.EnvironmentConfigService), i0.inject(i3.HttpClient), i0.inject(i4.UserService), i0.inject(i5.Store)); }, token: LabelsService, providedIn: "root" });
